import moment from 'moment';
import CryptoJS from 'crypto-js';
import api from 'services/api';
import {
  gridPageCountSelector,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid';
import { Pagination } from '@mui/material';

export const findOnArray = (value, arr = [], field) => {
  const rec = arr.find((i) => i.value === value);
  if (field) {
    return rec?.[field] || null;
  }
  return rec || null;
};

export const summarizer = (arr = [], field) =>
  arr?.length &&
  Number(
    arr
      ?.map((i) => i[field])
      ?.reduce((prev, next) => prev + next)
      ?.toFixed(2)
  );

export const checkInfosProduto = async ({ produto_id, ...rest }) => {
  const { data } = await api.get(`/Cadastros/Produto/${produto_id}`, {
    params: {
      ...rest,
      Midias: true,
      Descricao: true,
      Estruturas: true,
      Processos: true,
    },
  });
  const imagem = data?.ProdutoImagems?.find((f) => f?.Midium?.tipo === 'IMAGEM')
    ?.Midium?.url;
  const descricao = data?.ProdutoDescricaos?.find(
    (f) => f?.tipo === 'COMPLETA' || f?.tipo === 'REDUZIDA'
  )?.descricao;
  return { ...data, imagem, descricao };
};

export const openXML = (xml) => {
  const blob = new Blob([xml], { type: 'text/xml' });
  const url = URL.createObjectURL(blob);
  window.open(url);
  URL.revokeObjectURL(url);
};

export const getDatePagto = (values = {}) => {
  const {
    start_date,
    entrada,
    parcela,
    fora,
    intervalop,
    intervalo,
    fixar,
    dia,
  } = values;

  const numeroParcela = Number(parcela);
  const intervaloNormal = Number(intervalo || 0);
  const intervaloPrimeiraParcela = Number(intervalop);

  if (!Number.isInteger(numeroParcela) || numeroParcela <= 0) {
    return null;
  }

  const dataInicial =
    start_date && moment(start_date).isValid()
      ? moment(start_date).startOf('day')
      : moment().startOf('day');

  let data = dataInicial.clone();

  const possuiEntrada = entrada === 'SIM';

  const possuiIntervaloPrimeiraParcela =
    intervalop !== null &&
    intervalop !== undefined &&
    intervalop !== '' &&
    Number.isFinite(intervaloPrimeiraParcela) &&
    intervaloPrimeiraParcela >= 0;

  /*
   * Define o dia que será fixado.
   *
   * fixar selecionado:
   * usa o dia da data inicial.
   *
   * fixar não selecionado e dia informado:
   * usa o dia informado.
   */
  let diaFixo = null;

  if (fixar) {
    diaFixo = dataInicial.date();
  } else if (
    dia !== null &&
    dia !== undefined &&
    dia !== '' &&
    Number.isInteger(Number(dia)) &&
    Number(dia) >= 1 &&
    Number(dia) <= 31
  ) {
    diaFixo = Number(dia);
  }

  const possuiDiaFixo = diaFixo !== null;

  /*
   * A parcela de entrada vence no dia seguinte.
   */
  if (possuiEntrada && numeroParcela === 1) {
    return data.add(1, 'day').format('YYYY-MM-DD');
  }

  /*
   * Índice da parcela normal, desconsiderando a entrada.
   *
   * Sem entrada:
   * parcela 1 = parcela normal 1
   * parcela 2 = parcela normal 2
   *
   * Com entrada:
   * parcela 1 = entrada
   * parcela 2 = parcela normal 1
   * parcela 3 = parcela normal 2
   */
  const parcelaNormal = possuiEntrada ? numeroParcela - 1 : numeroParcela;

  /*
   * Mantém o comportamento da API:
   * quando existe entrada, a data base avança um dia.
   */
  if (possuiEntrada) {
    data.add(1, 'day');
  }

  /*
   * Adiciona o período inicial configurado em "fora".
   */
  switch (fora) {
    case 'SEMANA':
      data.add(1, 'week');
      break;

    case 'QUINZENA':
      data.add(15, 'days');
      break;

    case 'MES':
      data.add(1, 'month');
      break;

    case 'ANO':
      data.add(1, 'year');
      break;

    default:
      break;
  }

  /*
   * Adiciona um intervalo à data.
   *
   * Múltiplos de 30 são tratados como meses:
   * 30 = 1 mês
   * 60 = 2 meses
   * 90 = 3 meses
   *
   * Outros valores são tratados como dias.
   */
  const adicionarIntervalo = (valor, quantidade = 1) => {
    const intervaloValor = Number(valor);

    if (
      !Number.isFinite(intervaloValor) ||
      intervaloValor <= 0 ||
      quantidade <= 0
    ) {
      return;
    }

    if (intervaloValor % 30 === 0) {
      data.add((intervaloValor / 30) * quantidade, 'month');
    } else {
      data.add(intervaloValor * quantidade, 'days');
    }
  };

  /*
   * Intervalo entre a data base e a primeira parcela normal.
   *
   * Quando intervalop não estiver informado,
   * usa o intervalo normal.
   */
  const primeiroIntervalo = possuiIntervaloPrimeiraParcela
    ? intervaloPrimeiraParcela
    : intervaloNormal;

  /*
   * Toda primeira parcela normal recebe o primeiro intervalo.
   *
   * No seu exemplo:
   * 04/08/2026 + intervalop 30 = 04/09/2026.
   */
  adicionarIntervalo(primeiroIntervalo);

  /*
   * Da segunda parcela normal em diante,
   * adiciona o intervalo normal.
   */
  if (parcelaNormal >= 2) {
    adicionarIntervalo(intervaloNormal, parcelaNormal - 1);
  }

  /*
   * Aplica o dia fixo no mês calculado.
   *
   * Se o mês não possuir o dia configurado,
   * utiliza o último dia do mês.
   */
  if (possuiDiaFixo) {
    const ultimoDiaDoMes = data.daysInMonth();

    data.date(Math.min(diaFixo, ultimoDiaDoMes));
  }

  return data.format('YYYY-MM-DD');
};

export const encryptURL = (word, key = 'E-Solution') => {
  let encJson = CryptoJS.AES.encrypt(JSON.stringify(word), key).toString();
  let encData = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(encJson));
  return encData;
};

export const decryptURL = (word, key = 'E-Solution') => {
  let decData = CryptoJS.enc.Base64.parse(word).toString(CryptoJS.enc.Utf8);
  let bytes = CryptoJS.AES.decrypt(decData, key).toString(CryptoJS.enc.Utf8);
  try {
    const a = JSON.parse(bytes);
    return a;
  } catch (error) {
    return null;
  }
};

export const removeFalseKeys = (obj) => {
  Object.keys(obj).map((key) => {
    if (
      typeof obj[key] === 'object' &&
      Boolean(obj[key]) &&
      Object.keys(obj[key]).length > 0
    ) {
      removeFalseKeys(obj[key]);
    } else {
      if (
        (!Boolean(obj[key]) && obj[key] !== 0) ||
        (Object.keys(obj[key]).length === 0 && typeof obj[key] === 'object') ||
        obj[key] === 'NaN'
      ) {
        delete obj[key];
      }
    }
  });
};

export const filterSearch = (data = [], value = '') =>
  data?.filter((f) => {
    return Object.keys(f).some(
      (key) =>
        (f[key] || '')
          ?.toString()
          ?.toLowerCase()
          ?.indexOf(value?.toLowerCase()) !== -1
    );
  });

export const paginateArray = (array, pageNumber, pageSize) => {
  const startIndex = (pageNumber - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  return array.slice(startIndex, endIndex);
};

export const CustomPagination = () => {
  const gridRef = useGridApiContext();
  const count = useGridSelector(gridRef, gridPageCountSelector);
  return (
    <Pagination
      color="primary"
      count={count}
      onChange={(_, value) => gridRef?.current?.setPage(value - 1)}
    />
  );
};

export const generateUUID = (arr = []) => {
  const generator = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };

  let uuid = generator();

  return arr.some((a) => a?.uuid === uuid) ? generateUUID(arr) : uuid;
};
